// extracted by mini-css-extract-plugin
export default {"button":"ArticleBooking_button__hWVO8","buttonWrapper":"ArticleBooking_buttonWrapper__ILptu"};